import { Toaster as Sonner } from 'sonner';

/**
 * shadcn Sonner toaster — no next-themes; CRM uses its own dark-theme CSS.
 * ToastManager routes all legacy show/success/error calls through sonner.
 */
function Toaster({ ...props }) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:p-[var(--space-2)] group-[.toaster]:text-[length:var(--font-body)] group-[.toaster]:gap-[var(--space-1)]',
          title: 'group-[.toast]:text-[length:var(--font-body)] group-[.toast]:font-semibold',
          description:
            'group-[.toast]:text-muted-foreground group-[.toast]:text-[length:var(--font-label)]',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:text-[length:var(--font-label)]',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:text-[length:var(--font-label)]',
          success: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-success',
          error: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-destructive',
          warning: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-warning',
          info: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-info',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
